<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Bana ait Mail Hesabı</h4>
              <p class="card-category">Müşterilere mail göndermek için bu mail adresi kullanılacaktır.</p>
            </template>


            <form class="m-5">
              <div class="row">
                <div class="col-md-4">
                  <base-input type="email" label="Email" placeholder="Email" v-model="payload.mail">
                  </base-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <base-input type="number" label="Port" placeholder="Port" v-model="payload.port">
                  </base-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <base-input type="text" label="Host" placeholder="Host" v-model="payload.host">
                  </base-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <base-input type="text" label="password" placeholder="password" v-model="payload.password">
                  </base-input>
                </div>
              </div>



              <div class="text-center">
                <button type="submit" class="btn btn-info btn-fill float-right" @click="createNewFromMail">
                  Oluştur
                </button>
              </div>
              <div class="clearfix"></div>
            </form>


          </card>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Card from 'src/components/Cards/Card.vue'
  import CollectionService from "../../services/collection.service.js";

  export default {
    components: {
      Card
    },
    data() {
      return {
        payload: {},
      }
    },
    mounted() {
    },
    methods: {
      createNewFromMail() {
        CollectionService.postWidthAuth('frommail', this.payload).then((res) => {
          if (res.success == true) {
            this.$router.push(`/admin/fromMails`);
          } else {
            console.log('error');
            this.notifyVue('bottom', 'right', res.body)
          }
        }).catch(err=>{
            this.notifyVue('bottom', 'right', err)
        })
      },
      notifyVue (verticalAlign, horizontalAlign, message) {
        this.$notifications.notify(
          {
            message:  JSON.stringify(message),
            icon: '',
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type: 'danger'
          })
      }
    }
  }
</script>
<style>
</style>